import { createQuery } from 'effector-apollo'

import client from 'src/apollo/client'

export type { DrugConfiguration, DrugInformation, Configuration } from './types'

import { DRUG_CONFIGURATION_QUERY } from './graphql'

export const loadOptionsQuery = createQuery({
  document: DRUG_CONFIGURATION_QUERY,
  client,
})

export const $drugData = loadOptionsQuery.$data.map((data) =>
  data?.drugConfiguration.kind === 'SingleFlatDrugConfiguration'
    ? data.drugConfiguration
    : null,
)
